<template>
    <div v-if="chartData">
        <div id="enterprise-forecast" style="width:1680px; height:558px;"></div>
    </div>
    <div v-else>
        <div style="line-height:500px">暂无数据</div>
    </div>
</template>

<script>
/* eslint-disable */

import * as echarts from "echarts";
import EventBus from "../js/event-bus";

export default {
    name: "EnterpriseForecast",
    data() {
        return {
            chartData: null,
        };
    },
    mounted() {
        EventBus.$on("showOrganizationDetail", (organizationId) => {
            if (!organizationId) {
                return;
            }
            this.getManufactureMonthlyForecast(organizationId);
        });
    },
    methods: {
        getManufactureMonthlyForecast(organizationId) {
            this.$api
                .getManufactureMonthlyForecast(organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.chartData = result.data;
                        setTimeout(() => {
                            this.drawLine();
                        }, 500);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        drawLine() {
            echarts
                .init(document.getElementById("enterprise-forecast"))
                .dispose(); // 销毁实例
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(
                document.getElementById("enterprise-forecast")
            );

            var series = [];
            this.chartData.data.forEach((x) => {
                series.push({
                    name: x.hwName1,
                    type: "line",
                    //stack: "总量",
                    data: x.values,
                    smooth: true,
                });
            });

            // 绘制图表
            myChart.setOption({
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    //data: this.chartData.data.map((x) => x.hwName1),
                    orient: "vertical",
                    left: "right",
                    textStyle: {
                        color: "#cce2fc",
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: this.chartData.months,
                },
                yAxis: {
                    type: "value",
                },
                series: series,
            });
        },
    },
};
</script>

<style lang="less"></style>
